
<div class="w-full flex justify-between items-center">
  @for (step of steps; track step; let i = $index) {
    <div class="flex justify-between items-top" [class.w-full]="i !== 0">
      @if (i !== 0) {
        <div class="border-dotted border-b-4 border-gray-300 h-4 w-full" [class.pipeline-way-active]="i &lt;= currentStepIndex" [class.pipeline-way-inactive]="i &gt; currentStepIndex"></div>
      }
      <div class="flex justify-center items-center flex-col" [class.mr-2]="i === 0">
        <div class="rounded-full h-8 w-8 p-0 flex items-center justify-center" [class.pipeline-step-active]="i &lt;= currentStepIndex" [class.pipeline-step-inactive]="i &gt; currentStepIndex">{{i + 1}}</div>
        <div class="flex items-center text-center text-sm text-gray-300 whitespace-nowrap max-w-xs" [class.pipeline-title-active]="i &lt;= currentStepIndex" [class.pipeline-title-inactive]="i &gt; currentStepIndex">{{step.title}}</div>
      </div>
    </div>
  }
</div>